import React from "react";
import { useNavigate } from "react-router-dom";
import Debut0 from "./svg/SinglePlayerGame";
import Debut1 from "./svg/MultiPlayerGame";
import Debut3 from "./svg/Highscores";
import Debut4 from "./svg/PlayerSetup";
import Debut5 from "./svg/Options";
import Debut6 from "./svg/Register";
import "./home.css";

const Home: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="home-container">
      <div className="home-content">
        <div className="logo-container">
          <img src="/images/debuto.svg" alt="Quadra" className="main-logo" />
        </div>
        <div className="menu-container">
          <div className="menu-item" onClick={() => navigate("/single-player/settings")}>
            <Debut0 title="Start Game" />
          </div>
          <div className="menu-item" onClick={() => navigate("/multi-player")}>
            <Debut1 title="Multiplayer Game" />
          </div>
          <div className="menu-item">
            <Debut3 title="Highscores" />
          </div>
          <div className="menu-item" onClick={() => navigate("/player-setup")}>
            <Debut4 title="Player Setup" />
          </div>
          <div className="menu-item" onClick={() => navigate("/settings")}>
            <Debut5 title="Options" />
          </div>
          <div className="menu-item">
            <Debut6 title="Register" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
